import { strtrim, strempty } from './utils'

function setError(msg) {
    $('.error-message-3').text(msg)
    $('.error-message-3').css('display', 'block')
}

function setSuccess() {
    $('.success-message').css('display', 'block')
}

window.onload = () => {

    $('#email-form').on('submit', ev => {
        ev.preventDefault()
        ev.stopPropagation()
        ev.stopImmediatePropagation()

        onSubmit()

        $('.error-message-3').text('')
        $('.error-message-3').css('display', 'none')

        return false
    })

    $('#forgot-btn').on('click', ev => {
        ev.preventDefault()

        onSubmit()
    })

    function onSubmit() {
        const email = strtrim($('#Email').val())
        if (strempty(email)) {
            alert('Please specify your email.')
            return
        }

        $.ajax({
            method: 'POST',
            url: `${window.apiHost}/api/v1/requests/password-reset`,
            data: JSON.stringify({
                email: email,
            }),
            dataType: 'json',
            contentType: 'application/json',
            error: (response) => {
                console.log('failure response=%O', response.responseJSON)
                const code = response.responseJSON.code
                if (code === 'not_found') {
                    alert('A user with that email was not found in our system.')
                } else {
                    alert('Failed to send password recovery email.')
                }
            }
        })
        .done(response => {
            setSuccess()
        })

    }
}
